import React from "react";
import { useParams } from "react-router-dom";
import { api, ASSET_URL } from "../lib/api";
import { useSite } from "../lib/site-context";
import SectionRenderer from "../components/sections/SectionRenderer";
import { applySeo, injectJsonLd } from "../lib/seo";

export default function PublicPage({ slug: forcedSlug }) {
  const params = useParams();
  const slug = forcedSlug || params.slug || "home";
  const [page, setPage] = React.useState(null);
  const [mediaMap, setMediaMap] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  const { lang } = useSite();

  React.useEffect(() => {
    let cancelled = false;
    setLoading(true);
    Promise.all([
      api.page(slug).catch(() => null),
      api.media().catch(() => []),
      api.settings().catch(() => ({})),
    ]).then(([p, media, settings]) => {
      if (cancelled) return;
      setPage(p);
      const mm = Object.fromEntries((media || []).map(m => [m.id, m]));
      setMediaMap(mm);
      const seo = (lang === "en" ? p?.seo_en : p?.seo_de) || {};
      const baseUrl = settings?.public_base_url || process.env.REACT_APP_SITE_URL || "";
      const ogId = seo.og_image_id;
      const ogImage = ogId && mm[ogId] ? ASSET_URL(mm[ogId].variants?.webp || mm[ogId].variants?.original) : undefined;
      const pageTitle = lang === "en" ? (p?.title_en || p?.title_de) : p?.title_de;
      applySeo({ slug, seo: { ...seo, title: seo.title || pageTitle }, lang, siteName: settings?.site_name || "Dr. B.-Digitec", baseUrl, ogImage });
    }).catch(() => {}).finally(() => { if (!cancelled) setLoading(false); });
    // Per-page JSON-LD (server-built graph)
    api.seoJsonLd(slug, lang).then(g => { if (!cancelled) injectJsonLd(g); }).catch(() => {});
    return () => { cancelled = true; injectJsonLd(null); };
  }, [slug, lang]);

  if (loading) return <div className="pt-40 text-center font-mono text-xs tracking-[0.3em] uppercase opacity-50">Lädt …</div>;
  if (!page) return <div className="pt-40 text-center"><h2 className="brut-h2">404 — Seite nicht gefunden</h2></div>;
  const isLegal = ["impressum", "datenschutz"].includes(page.slug || slug);
  return (
    <main className={isLegal ? "legal-page" : ""}>
      <SectionRenderer sections={page.sections} media={mediaMap} />
    </main>
  );
}
